import { Link, Outlet } from 'react-router-dom';

import List from './List';
import Report from './Report';
import CreateStaffForm from './forms/CreateStaff.form';
import UpdateStaffForm from './forms/UpdateStaff.form';

import Meta from "../../components/Meta";
import Header from "../../components/Header";

function Template() {
	return (
		<>
			<Meta title="Staff" />
			<Header heading={"Staff Members"} button={<Link to="create" className="btn btnPrimary">+ Add Staff</Link>} />
			<main>
				<Outlet />
			</main>
		</>
	)
}

export default {
	Template,
	List,
	Report,
	Create: CreateStaffForm,
	Update: UpdateStaffForm
};
